export function sortAutocompleteResults(queryValue, results) {
    if (results && results.length > 0) {
        const typeOrder = {
            'continent': 1,
            'country': 2,
            'state': 3,
            'region': 4,
            'province': 5,
            'district': 6,
            'county': 7,
            'municipality': 8,
            'city': 9,
            'town': 10,
            'suburb': 11,
            'quarter': 12,
            'neighbourhood': 13,
            'village': 14,
            'hamlet': 15,
            'locality': 16,
            'island': 17,
            'archipelago': 18,
            'postcode': 19,
            'house': 20,
            'others': 21 // reszta typów
        };
        queryValue = queryValue.toLowerCase();
        return results.sort((a, b) => {
            const addressStringA = extractAddressString(a).toLowerCase();
            const addressStringB = extractAddressString(b).toLowerCase();

            // Sprawdź, czy wynik zaczyna się od queryValue
            const startsWithQueryValueA = addressStringA.startsWith(queryValue);
            const startsWithQueryValueB = addressStringB.startsWith(queryValue);

            // Jeśli a zaczyna się od queryValue, a b nie, to a powinno być przed b
            if (startsWithQueryValueA && !startsWithQueryValueB) {
                return -1;
            }
            // Jeśli b zaczyna się od queryValue, a a nie, to b powinno być przed a
            else if (!startsWithQueryValueA && startsWithQueryValueB) {
                return 1;
            }
            // Jeśli oba zaczynają się od queryValue lub żaden, porównaj je według typu
            else {
                const aTypePriority = typeOrder[a.type] || typeOrder['others'];
                const bTypePriority = typeOrder[b.type] || typeOrder['others'];

                // Jeśli typy są takie same, porównaj alfabetycznie
                if (aTypePriority === bTypePriority) {
                    return addressStringA.localeCompare(addressStringB);
                }
                // W przeciwnym razie porównaj po priorytetach typów
                else {
                    return aTypePriority - bTypePriority;
                }
            }
        });
    } else {
        return results;
    }
}


export function extractAddressString(osmObject, withFormatting = false) {
    const address = osmObject.address || {};
    const displayPlace = osmObject.display_place || '';

    const placeTypes = {
        country: (a) => [a.country],
        state: (a) => [a.state, a.country],
        region: (a) => [a.region, a.country],
        state_district: (a) => [a.state_district, a.state, a.country],
        county: (a) => [a.county, a.state, a.country],
        city: (a) => [a.city, a.state, a.country],
        town: (a) => [a.town, a.state, a.country],
        village: (a) => [a.village, a.state, a.country],
        suburb: (a) => [a.suburb, a.city, a.state, a.country],
        neighbourhood: (a) => [a.neighbourhood, a.suburb, a.city, a.state, a.country],
        road: (a) => [a.road, a.neighbourhood, a.suburb, a.city, a.state, a.country],
        house_number: (a) => [`${a.house_number} ${a.road}`, a.neighbourhood, a.suburb, a.city, a.state, a.country],
        postcode: (a) => [a.postcode, a.city, a.state, a.country],
        university: (a) => [a.name, a.road, a.city, a.state, a.country],
        train_station: (a) => [a.name, a.road, a.city, a.state, a.country],
        bus_station: (a) => [a.name, a.road, a.city, a.state, a.country],
        hospital: (a) => [a.name, a.road, a.city, a.state, a.country],
        company: (a) => [a.name, a.road, a.city, a.state, a.country],
        amenity: (a) => [a.name, a.road, a.city, a.state, a.country]
    };

    const placeType = osmObject.type;
    const formatArray = placeTypes[placeType];

    if (formatArray) {
        const formattedParts = [displayPlace, ...formatArray(address)].filter(Boolean);
        if (formattedParts.length > 1) {
            if (formattedParts[0] === formattedParts[1]) {
                formattedParts.shift();
            }
        }
        if (formattedParts.length > 0) {
            formattedParts[0] = `${withFormatting ? '<b>' : ''}${formattedParts[0]}${withFormatting ? '</b>' : ''}`;
        }
        return formattedParts.join(', ');
    } else {
        return osmObject.display_name ? `${withFormatting ? '<b>' : ''}${osmObject.display_name}${withFormatting ? '</b>' : ''}` : '';
    }
}